export enum EmployeeDetailsSalesView {
  List = 0,
  Event = 1
}
